import NewmanPrizestyles from './NewmanPrize.module.css'; // We'll define background styling here
import Header from './Header';

const NewmanPrize = () => {
  return (
    
    <div className= {NewmanPrizestyles.newman_prize_background}>
      <Header />
    </div>
  );
};

export default NewmanPrize;

